<script>
import { ref, reactive } from 'vue';
import useVuelidate from '@vuelidate/core';
import {
  helpers, required, email, maxLength, minLength,
} from '@vuelidate/validators';
import { PUBLIC_KEY } from '../config';
import UserService from '../services/UserService';

export default {
  name: 'Home',
  setup() {
    const planDonation = ref(1);
    const showIframe = ref(false);
    const paid = ref(false);
    const singleCharge = ref(false);

    const rules = {
      email: {
        required: helpers.withMessage('El email es requerido', required),
        email: helpers.withMessage('No es un email válido', email),
      },
      name: {
        required: helpers.withMessage('El nombre es requerido', required),
      },
      phone: {
        required: helpers.withMessage('El teléfono es requerido', required),
        maxLength: helpers.withMessage('Solo 10 digitos', maxLength(10)),
        minLength: helpers.withMessage('Solo 10 digitos', minLength(10)),
      },
    };

    const form = reactive({
      name: '',
      email: '',
      phone: '',
    });

    const v$ = useVuelidate(rules, form);
    v$.value.$touch();

    const createOrder = async () => {
      showIframe.value = true;
      try {
        console.log(form);
        const response = await UserService.createOrder(form.name, form.email, form.phone, planDonation.value);
        const config = {
          checkoutRequestId: response.data.checkout.id,
          locale: 'es',
          targetIFrame: '#conektaIframeContainer',
          publicKey: PUBLIC_KEY,
          options: {},
          styles: {},
          onFinalizePayment: async (paymentData) => {
            showIframe.value = false;
            paid.value = true;
            const newData = {
              ...paymentData,
              ...response.data,
              planDonation: planDonation.value,
              singleCharge: singleCharge.value,
            };
            await UserService.saveOrder(newData);
          },
        };

        window.ConektaCheckoutComponents.Integration(config);
      } catch (error) {
        showIframe.value = false;
        alert(error.message);
      }
    };

    return {
      createOrder,
      planDonation,
      showIframe,
      paid,
      singleCharge,
      v$,
    };
  },
};
</script>

<template>
  <div>
    <aside
      class="sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 fixed-start ms-3 d-none d-lg-block"
      id="sidenav-main" data-color="success">
      <div class="sidenav-header">
        <a class="navbar-brand m-0" href="#" target="_blank">
          <img src="/assets/img/todo-inclusion.png" class="navbar-brand-img h-100" alt="main_logo">
        </a>
      </div>
      <hr class="horizontal dark mt-0">
      <div class="collapse navbar-collapse w-auto" id="sidenav-collapse-main">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link active" href="../pages/dashboard.html">
              <div
                class="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                <svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink">
                  <title>shop </title>
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero">
                      <g transform="translate(1716.000000, 291.000000)">
                        <g transform="translate(0.000000, 148.000000)">
                          <path class="color-background opacity-6"
                            d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z">
                          </path>
                          <path class="color-background"
                            d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z">
                          </path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <span class="nav-link-text ms-1">Inicio</span>
            </a>
          </li>
          <hr class="horizontal dark mt-0">
          <li class="nav-item">
            <router-link :to="{ name: 'ReceiptForm' }" class="nav-link">
              <div
                class="icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                <i class="fas fa-file-invoice text-lg"></i>
              </div>
              <span class="nav-link-text ms-1">Recibo</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'CancelSuscription' }" class="nav-link">
              <div
                class="icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                <i class="fas fa-file-invoice text-lg"></i>
              </div>
              <span class="nav-link-text ms-1">Cancelar suscripción</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'Legal' }" target='_blank' class="nav-link">
              <div
                class="icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                <i class="fas fa-file-contract text-lg"></i>
              </div>
              <span class="nav-link-text ms-1">Aviso de Privacidad</span>
            </router-link>
          </li>
        </ul>
      </div>
    </aside>
    <main class="main-content position-relative max-height-vh-100 h-100 bg-gray-100 overflow-y-scroll">
      <!-- Navbar -->
      <nav
        class="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl position-sticky blur shadow-blur mt-4 left-auto top-1 z-index-sticky"
        id="navbarBlur" navbar-scroll="true">
        <div class="container-fluid py-1 px-3">
          <div class="d-block d-sm-none">
            <a class="navbar-brand m-0" href="#" target="_blank">
              <img src="/assets/img/todo-inclusion.png" class="navbar-brand-img w-100" alt="main_logo">
            </a>
          </div>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
              <li class="breadcrumb-item text-sm"><a class="opacity-5 text-dark" href="https://todoinclusion.org">Todo
                  Inclusión</a>
              </li>
              <li class="breadcrumb-item text-sm text-dark active" aria-current="page">Donativos</li>
            </ol>
            <h6 class="font-weight-bolder mb-0">Transformemos vidas juntos</h6>
          </nav>
        </div>
      </nav>
      <!-- End Navbar -->
      <div class="container-fluid py-4">
        <div class="row mt-4">
          <div class="col-lg-7 mb-lg-0 mb-4">
            <div class="card" style="min-height: 300px;">
              <div class="card-body p-3">
                <div class="row justify-content-around">
                  <div class="col-lg-4">
                    <div class="d-flex flex-column h-100">
                      <p class="mb-1 pt-2 text-bold">Persona a Persona</p>
                      <h5 class="font-weight-bolder">Donativo</h5>
                      <p class="mb-5">Tu aportación ayuda a completar el tratamiento de otra persona</p>
                    </div>
                  </div>
                  <div class="col-lg-8 mt-0 mt-lg-2 ">
                    <img src="/assets/img/salud-1.png" class="w-100" alt="waves">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5">
            <div class="card h-100" style="min-height: 300px;">
              <iframe class="border-radius-lg" width="100%" height="100%"
                src="https://www.youtube.com/embed/QznhmMS3ye8?controls=0" title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen></iframe>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-lg-12">
            <p>Rellena los siguientes datos</p>
            <div class="row">
              <div class="col-md-4">
                <label>Nombre</label>
                <div class="mb-3">
                  <input type="email" class="form-control" placeholder="Nombre" aria-label="Nombre"
                    aria-describedby="email-addon" v-model="v$.name.$model">
                  <span class="text-danger" v-if="v$.name.$error">
                    {{ v$.name.$errors.map(({ $message }) => $message).join(', ') }}
                  </span>
                </div>
              </div>
              <div class="col-md-4">
                <label>Email</label>
                <div class="mb-3">
                  <input type="email" class="form-control" placeholder="Email" aria-label="Email"
                    aria-describedby="email-addon" v-model="v$.email.$model">
                  <span class="text-danger" v-if="v$.email.$error">
                    {{ v$.email.$errors.map(({ $message }) => $message).join(', ') }}
                  </span>
                </div>
              </div>
              <div class="col-md-4">
                <label>Teléfono</label>
                <div class="mb-3">
                  <input type="number" class="form-control" placeholder="Teléfono" aria-label="Phone"
                    aria-describedby="email-addon" v-model="v$.phone.$model" maxlength="10">
                  <span class="text-danger" v-if="v$.phone.$error">
                    {{ v$.phone.$errors.map(({ $message }) => $message).join(', ') }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-lg-12">
            <p>Selecciona la cantidad de tu donativo</p>
            <div class="row">
              <div class="col-xl-12" v-if="!showIframe && !paid">
                <div class="row">
                  <div class="col-md-4 p-1">
                    <div class="card my-sm-3 my-md-0" role="button" @click="planDonation = 1"
                      :class="{ 'shadow border-2 border-success': planDonation == 1 }">
                      <div class="card-header mx-4 p-3 text-center">
                        <div class="icon icon-shape icon-lg bg-gradient-success shadow text-center border-radius-lg">
                          <i class="opacity-10 fas fa-receipt"></i>
                        </div>
                      </div>
                      <div class="card-body pt-0 p-3 text-center">
                        <h6 class="text-center mb-0">Donativo</h6>
                        <span class="text-xs">Base</span>
                        <hr class="horizontal dark my-3">
                        <h5 class="mb-0">$50</h5>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 p-1">
                    <div class="card my-sm-3 my-md-0" role="button" @click="planDonation = 2"
                      :class="{ 'shadow border-2 border-success': planDonation == 2 }">
                      <div class="card-header mx-4 p-3 text-center">
                        <div class="icon icon-shape icon-lg bg-gradient-success shadow text-center border-radius-lg">
                          <i class="opacity-10 fas fa-receipt"></i>
                        </div>
                      </div>
                      <div class="card-body pt-0 p-3 text-center">
                        <h6 class="text-center mb-0">Donativo</h6>
                        <span class="text-xs">Medio</span>
                        <hr class="horizontal dark my-3">
                        <h5 class="mb-0">$200</h5>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 p-1">
                    <div class="card my-sm-3 my-md-0" role="button" @click="planDonation = 3"
                      :class="{ 'shadow border-2 border-success': planDonation == 3 }">
                      <div class="card-header mx-4 p-3 text-center">
                        <div class="icon icon-shape icon-lg bg-gradient-success shadow text-center border-radius-lg">
                          <i class="opacity-10 fas fa-receipt"></i>
                        </div>
                      </div>
                      <div class="card-body pt-0 p-3 text-center">
                        <h6 class="text-center mb-0">Donativo</h6>
                        <span class="text-xs">Alto</span>
                        <hr class="horizontal dark my-3">
                        <h5 class="mb-0">$500</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <p class="text-center h6 m-0">
                    Se creara un cargo recurrente (mensual), si sólo deseas hacer una única donación
                    selecciona la opción de abajo
                  </p>
                  <div class="form-group text-center">
                    <input type="checkbox" name="only" id="only" v-model="singleCharge">
                    <label for="only">
                      <p class="m-0">
                        Único cargo
                      </p>
                    </label>
                  </div>
                  <div class="col-12 d-flex justify-content-center">
                    <button class="btn btn-info" v-if="planDonation > 0" @click="createOrder()" :disabled="v$.$invalid">
                      DONAR
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mb-lg-0 mb-4" v-if="showIframe">
                <div class="card mt-4">
                  <div class="card-body p-3">
                    <div class="row">
                      <div class="col-md-12 mb-md-0 mb-4">
                        <div id="conektaIframeContainer" style="height: 500px;"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mb-lg-0 mb-4" v-if="!showIframe && paid">
                <div class="card m-1 p-3">
                  <div class="row justify-content-center">
                    <div class="col-4 text-center">
                      <p class="">
                        En un momento recibirás una confirmación en tu correo electrónico
                      </p>
                      <router-link :to="{ name: 'ReceiptForm' }" class="btn btn-info m-0">
                        Solicita tu recibo 100% deducible de impuestos
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer class="footer pt-3 ">
          <div class="container-fluid">
            <div class="row align-items-center justify-content-lg-center">
              <div class="col-12 mb-lg-0 mb-4">
                <div class="copyright text-center text-sm text-muted text-lg-center">
                  © 2023,
                  made with <i class="fa fa-heart"></i> by Todo Inclusión -
                  Based on <a href="https://www.creative-tim.com" class="font-weight-bold" target="_blank">Creative
                    Tim</a>
                  design.
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </main>
  </div>
</template>

<style lang="scss">
@import "@/scss/views/home.scss";
</style>
